class TripleAlkaloid extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    const swiperEl = this.querySelector('.section-triple-alkaloid-slider');
    if (!swiperEl) return;

    const isDesktop = window.innerWidth > 767;

    const navigationWrapper = isDesktop
      ? this.querySelector('.section-triple-alkaloid-navigation-desktop')
      : this.querySelector('.section-triple-alkaloid-navigation-mobile');

    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1.2,
      spaceBetween: 24,

      breakpoints: {
        540: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 0
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 0
        }
      },

      pagination: {
        el: navigationWrapper.querySelector('.swiper-pagination'),
        clickable: true
      },

      navigation: {
        nextEl: navigationWrapper.querySelector('.swiper-button-next'),
        prevEl: navigationWrapper.querySelector('.swiper-button-prev')
      }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

customElements.define('triple-alkaloid', TripleAlkaloid);